import { swrFetch } from 'src/utils/swrFetch';
import useSWR from 'swr';

export const useTree = () => {
    return useSWR(`/sites/site-tree`, swrFetch, {
        suspense: false,
    });
};
